module.exports = __webpack_public_path__ + "static/media/not-found.6060ea6f.png";